import { SERVICES } from "@/data/services";

export const inputCls =
  "w-full h-10 px-3 border border-zinc-300 bg-white text-sm focus:outline-none focus:border-[#0044FF] transition-colors";

export function ServiceSelect({ value, onChange, testId }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={testId}>
      {SERVICES.map((s) => (
        <option key={s.slug} value={s.slug}>{s.title}</option>
      ))}
    </select>
  );
}

export function HomeSwitch({ checked, onChange, testId }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      data-testid={testId}
      className={`relative w-11 h-6 transition-colors ${checked ? "bg-[#0044FF]" : "bg-zinc-300"}`}
    >
      <span className={`absolute top-1 w-4 h-4 bg-white transition-transform ${checked ? "translate-x-6" : "translate-x-1"} left-0`} />
    </button>
  );
}
